export default __webpack_public_path__ + "static/media/the_star.3a545aa2.png";